// extracted by mini-css-extract-plugin
module.exports = {"scorePanel":"Score_scorePanel__Mo0rE","scoreHeader":"Score_scoreHeader__1_pRL","score":"Score_score__dyp5s","nimbus":"Score_nimbus__391vA","winNimbus":"Score_winNimbus__1MFvC"};